import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgKgItalic = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		d: "M22 2h-9.333m-1.334 20H2m4.667 0L17.333 2"
	})
});
export default SvgKgItalic;
